<img
  [defaultImage]="'assets/images/placeholder.png'"
  [errorImage]="'assets/images/placeholder.png'"
  [lazyLoad]="getImageLink()"
  [alt]="campaign.title"
/>
<div class="info">
  <div class="title">{{ campaign.title }}</div>
  <div class="description">
    <p>{{ campaign.description }}</p>
  </div>
  <div class="cta-btn" *ngIf="campaign.link">
    <a [href]="campaign.link">
      {{ campaign.button }}
    </a>
  </div>
</div>
